export default __webpack_public_path__ + "static/media/logo-light-bg.3db2960c.svg";